export default [
  { path: '/yeepay/merchant-apply', name: 'yeepay-merchant-apply', meta: { title: '易宝进件', hidden: false }, component: () => import('@/views/yeepay/MerchantApplyList') },
]
